import { render, staticRenderFns } from "./Grid3.vue?vue&type=template&id=0b725c59&scoped=true&"
import script from "./Grid3.vue?vue&type=script&lang=ts&"
export * from "./Grid3.vue?vue&type=script&lang=ts&"
import style0 from "./Grid3.vue?vue&type=style&index=0&id=0b725c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b725c59",
  null
  
)

export default component.exports